/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChangePasswordResponse {
    getFixupPrototypeFunction() { return ChangePasswordResponse.fixupPrototype; }

    static newInstance(model: Partial<ChangePasswordResponse>): ChangePasswordResponse {
        let obj = Object.assign(new ChangePasswordResponse(), model);
        ChangePasswordResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChangePasswordResponse>): ChangePasswordResponse {
        if (!model) return null;
        return ChangePasswordResponse.newInstance(<ChangePasswordResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChangePasswordResponse) {
        if (!obj) return;

        models.ChangePasswordResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChangePasswordResponse): boolean {
        Object.setPrototypeOf(obj, ChangePasswordResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the User to whom the password is changed
     */
    user_id: string;

}
